import { jsxs as g, jsx as o } from "react/jsx-runtime";
import { w as x, x as B, y as M, z as P, d as T, j as w, A, B as K } from "../../../vendor-CPVnY93G.js";
import { forwardRef as R, useRef as $, useContext as v } from "react";
import { BaseIcon as h } from "../../BaseIcon/index.js";
import { ItemRow as C } from "../../ItemRow/index.js";
import { Tag as I } from "../../Tag/index.js";
import { useSelectFieldValueContext as j } from "../SelectFieldContext/index.js";
import { c as r } from "../../../styles.module-BOlArovb.js";
const D = ({ buttonRef: d }) => {
  const n = v(x), { selectedItems: l } = j();
  if (!n || n.selectionManager.selectedKeys.size === 0)
    return null;
  const i = Array.from(n.selectionManager.selectedKeys), u = i.map((e) => {
    const t = l.get(e);
    return {
      id: String(e),
      textValue: t?.label ?? String(e),
      icon: t?.decorationLeft?.iconProps?.icon
    };
  });
  return /* @__PURE__ */ o(
    A,
    {
      "aria-label": "Selected options",
      className: r.tagGroup,
      onAction: () => {
        n.open();
      },
      onRemove: (e) => {
        const t = new Set(e), c = i.filter(
          (a) => !t.has(String(a)) && !t.has(a)
        );
        n.setValue(c), c.length === 0 && d.current && d.current.focus();
      },
      children: /* @__PURE__ */ o(K, { items: u, className: r.tagList, children: (e) => /* @__PURE__ */ o(I, { id: e.id, icon: e.icon, textValue: e.textValue, color: "blue" }) })
    }
  );
}, J = R(
  function({ placeholder: n, startIcon: l, ...i }, u) {
    const e = $(null), t = v(x), c = () => {
      t && (t.setValue([]), e.current?.focus());
    }, a = $(null), { hoverProps: y, isHovered: S } = B({}), { pressProps: V, isPressed: N } = M({
      onPress: c
    }), f = t ? Array.from(t.selectionManager.selectedKeys) : [], m = f.length > 0, p = (s) => {
      let b = s.target;
      b && (a.current?.contains(b) || e.current && (e.current.focus(), e.current.click()));
    };
    return /* @__PURE__ */ g(
      P,
      {
        ...i,
        ref: u,
        className: r.selectValue,
        onClick: p,
        onTouchEnd: p,
        onKeyDownCapture: (s) => {
          s.target == e.current && s.key == "Backspace" && (s.preventDefault(), s.stopPropagation(), c());
        },
        children: [
          /* @__PURE__ */ g("div", { className: r.multiValue, children: [
            l ? /* @__PURE__ */ o(C.DecorationLeft, { iconProps: { icon: l } }) : null,
            m ? /* @__PURE__ */ o(D, { buttonRef: e }) : /* @__PURE__ */ o("span", { className: r.placeholder, children: n })
          ] }),
          m && /* @__PURE__ */ o(
            "button",
            {
              ...V,
              ...y,
              "data-hovered": S || void 0,
              "data-pressed": N || void 0,
              type: "button",
              ref: a,
              tabIndex: -1,
              "aria-label": `Clear all ${f.length} selected options`,
              className: T(r.multiTriggerButton, r.clearButton),
              children: /* @__PURE__ */ o(h, { color: "moon", icon: "close" })
            }
          ),
          /* @__PURE__ */ o(w, { ref: e, className: r.multiTriggerButton, children: /* @__PURE__ */ o(h, { color: "moon", icon: "chevron-down", className: r.chevron }) })
        ]
      }
    );
  }
);
export {
  J as MultiSelectValue
};
